<oe-flat-widget [title]="'GENERAL.DAY_PRODUCTION' | translate"
[icon]="{name: 'oe-production', color: 'production'}"
button  class="signage-font-nowrap">
    <ng-container *ngFor="let component of productionMeterComponents, let i = index">
          <oe-flat-widget-line
          [name]="component.alias"
          [channelAddress]="component.id + '/ActiveProductionEnergyDaily'"
          [converter]="CONVERT_TO_KILO_WATTHOURS">
        </oe-flat-widget-line>
    </ng-container>
 </oe-flat-widget>


